<img
  *ngIf="renderedSource$ | async as source"
  [src]="source"
  [class.is-hidden]="imageHidden"
  (error)="onImageError()"
  alt=""
  aria-hidden="true"
  draggable="false"
>
